import { createSlice, nanoid } from '@reduxjs/toolkit';
import { RootState } from 'js/store';

export type SchoolClass = {
  id: string;
  name: string;
};
export const initialState: Array<SchoolClass> = [];

export const classSlice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    addClass: (state) => {
      const id = nanoid();
      const name = '';
      state.push({ id, name });
    },
    editClass: (state, { payload }) => {
      const { id, name } = payload;
      const schoolClass =
        state.find((schoolClass) => schoolClass.id === id) || undefined;
      schoolClass.name = name;
    },
    deleteClass: (state, { payload }) => {
      const { id } = payload;
      const classIndex = state.findIndex(
        (schoolClass) => schoolClass.id === id
      );
      classIndex > -1 && state.splice(classIndex, 1);
    },
  },
});

// Actions
export const { addClass, editClass, deleteClass } = classSlice.actions;

// Selectors
export const selectClasses = (state: RootState) => state.classes;
export const getClassNameById = (state: RootState, classId: string) => {
  const classes = selectClasses(state);
  const schoolClass = classes.find((schoolClass) => schoolClass.id === classId);
  return schoolClass ? schoolClass.name : '';
};

export default classSlice.reducer;
